import { Button, DatePicker, Input, Modal, Select } from "antd";
import React, { useState } from "react";
import { MdOutlineUnarchive } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import { OneCustomer } from "../../../Stores/Customers/OneCustomer";
import axiosInstance from "../../axiosInstance/AxiosInstance";
import formatNumberWithSpaces from "../../NumberToWords/FormatNumber";
const { Option } = Select;

export default function Arxiv({ setOpenSettings }) {
  const { id } = useParams();
  const { data, error, fetchData } = OneCustomer();
  let [open, setOpen] = useState(false);
  let [loading, setLoading] = useState(false);
  let [info, setInfo] = useState({
    dk: "",
    sum: "",
    comment: "",
    customer_id: id,
    archive_related: true,
  });
  let archiveUser = async () => {
    if (loading) return;
    try {
      setLoading(true);
      let { data } = await axiosInstance.post("/api/arkhiv/" + id, {
        ...info,
        customer_id: id,
        sum: Number(info?.sum),
      });
      console.log(data);
      fetchData(id);
      setOpen(false);
      setInfo({
        dk: "",
        sum: "",
        comment: "",
        customer_id: id,
        archive_related: true,
      });
      setOpenSettings(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Modal
        style={{ top: "10px" }}
        title="Ranglar"
        open={open}
        //   loading={loadVagon}
        onOk={() => {
          setOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setOpen(false);
        }}
        footer={[
          <Button
            disabled={loading}
            key="submit"
            dk="primary"
            onClick={() => {
              if (info?.dk?.length > 0 && info?.sum && !loading) {
                archiveUser();
              }
            }}
          >
            Saqlash
          </Button>,
        ]}
      >
        <div className="flex flex-col items-center gap-2">
          <div className="w-[100%] flex flex-col gap-1 items-center ">
            <label className="w-[100%] text-[14px] p-[0] m-[0]">
              Xaqdor / qarzdor
            </label>
            <Select
              onSelect={(e) => {
                console.log(e);
                setInfo({
                  ...info,
                  dk: e,
                });
              }}
              placeholder="Select an option"
              className="w-[100%]"
            >
              <Option value="d">Qarzdor</Option>
              <Option value="k">Xaqdor</Option>
            </Select>
          </div>
          <div className="w-[100%] flex flex-col gap-1 items-center ">
            <label className="w-[100%] text-[14px] p-[0] m-[0]">
              Summa {formatNumberWithSpaces(info?.sum)}
            </label>
            <Input
              className="w-[100%]"
              onChange={(e) => {
                console.log(e.target.value);
                setInfo({
                  ...info,
                  sum: e.target.value,
                });
              }}
              value={info?.sum}
              dk={"text"}
              placeholder="Summa miqdorini kiriting..."
            />
          </div>
          <div className="w-[100%] flex flex-col gap-1 items-center ">
            <label className="w-[100%] text-[14px] p-[0] m-[0]">Sana</label>
            <DatePicker
              className="w-[100%]"
              onChange={(date, dateString) => {
                setInfo({
                  ...info,
                  date: dateString,
                });
              }}
            />
          </div>
          <div className="w-[100%] flex flex-col gap-1 items-center ">
            <label className="w-[100%] text-[14px] p-[0] m-[0]">Izox</label>
            <Input.TextArea
              onChange={(e) => {
                console.log(e.target.value);
                setInfo({
                  ...info,
                  comment: e.target.value,
                });
              }}
              dk={"text"}
              rows={4}
              placeholder="Enter your text here..."
            />
          </div>
        </div>
      </Modal>
      <h2>Arxivlash</h2>
      <div>
        <p className="text-[15px] bold">
          Arxivlash -- Bu xaridor hissob kitoblari nol bo'lgan taqdirda yoki
          tugatilgan holda boshqa yangi sahifa ochish va eski hissoblarni tikib
          qo'yish.
        </p>

        <div>
          <h2 className="text-[12px] bold ">Etiborli bo'ling!</h2>
          <Button
            size="large"
            className="w-[100%] flex justify-start"
            icon={<MdOutlineUnarchive className="font-[30px]" />}
            color={"primary"}
            variant="filled"
            onClick={() => {
              setOpen(true);
            }}
          >
            Arxivlash
          </Button>
        </div>
        <div>
          <h2 className="text-[12px] bold ">Arxivlar tarixi!</h2>
        </div>
        <div>
          {data?.arkhiv?.archives?.map((el) => {
            return (
              <div>
                {" "}
                <Link
                  // to={`/api/arkhiv/${id}/${el?.archive_value}`}
                  to={`/customer/arkhiv/${id}?archive_value=${el?.archive_value}`}
                  className="text-[18px] bold "
                >
                  {el?.archived_at?.split("T")[0]} -{" "}
                  {el?.archived_at?.split("T")[1]}! = {"  "} {el?.archived_by}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
